"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _objectWithoutProperties2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _ModulePopup = _interopRequireDefault(require("./components/ModulePopup.vue"));
var _ossUpload = require("@/utils/ossUpload");
var _localLifeMobile = _interopRequireDefault(require("./localLifeMobile"));
var _creatApp = require("@/api/creatApp");
var _excluded = ["name", "actNum"],
  _excluded2 = ["modelName"]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    localLifeMobile: _localLifeMobile.default,
    ModulePopup: _ModulePopup.default
  },
  data: function data() {
    return {
      loading: false,
      activeNum: '',
      tableData: [{
        name: '搜索定位模块',
        enable: 0,
        actNum: 1,
        pic: '',
        textColor: '#000000',
        searchInfo: ''
      }, {
        name: '顶部轮播图',
        enable: 0,
        category: 2
      }, {
        name: '金刚区',
        enable: 0,
        category: 3
      }, {
        name: '三连块',
        enable: 0,
        category: 4
      }, {
        name: '二连块',
        enable: 0,
        category: 5
      }, {
        name: '中部轮播位',
        enable: 0,
        category: 6
      }, {
        name: '底部四连块',
        enable: 0,
        category: 7
      }, {
        name: '商品列表菜单栏',
        enable: 0,
        actNum: 8
      }
      // { name: '商品列表菜单栏11111', enable: 0, category: 9 }
      ],
      searchAndLocation: {
        pic: '',
        textColor: '#000000',
        searchInfo: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    var arr = [];
    this.tableData.map(function (i) {
      if (i.actNum) {
        arr.push("localLife_".concat(i.actNum));
      }
    });
    (0, _creatApp.getConfigList)({
      itemKeyList: arr
    }).then(function (res) {
      if (res.data && res.data.length > 0) {
        res.data.map(function (i) {
          return JSON.parse(i.itemValue);
        }).map(function (m) {
          _this.tableData.map(function (n) {
            if (m.actNum === n.actNum) {
              // eslint-disable-next-line no-unused-vars
              var name = m.name,
                actNum = m.actNum,
                newObj = (0, _objectWithoutProperties2.default)(m, _excluded);
              Object.assign(n, (0, _objectSpread2.default)({}, newObj));
            }
          });
        });
      }
    }).then(function () {
      console.log(_this.tableData, '===');
      _this.findAll();
    });
  },
  methods: {
    handleChildData: function handleChildData(val) {
      console.log(val, '----------');
      if (this.tableData[val - 1].category) {
        this.$refs.ModulePopup.open({
          name: this.tableData[val - 1].name,
          id: this.tableData[val - 1].id,
          region: this.tableData[val - 1].region,
          category: this.tableData[val - 1].category
        });
      }
      this.activeNum = val;
    },
    findAll: function findAll() {
      var _this2 = this;
      this.loading = true;
      (0, _creatApp.findAll)({
        region: 2
      }).then(function (res) {
        if (res.data && res.data.length > 0) {
          // let newList=[]
          _this2.tableData.map(function (i) {
            if (i.category) {
              res.data.map(function (m) {
                if (i.category * 1 === m.category * 1) {
                  // eslint-disable-next-line no-unused-vars
                  var modelName = m.modelName,
                    newObj = (0, _objectWithoutProperties2.default)(m, _excluded2);
                  Object.assign(i, (0, _objectSpread2.default)({}, newObj));
                }
              });
            }
          });
          var newArr = _this2.tableData.filter(function (i) {
            return !i.id && i.category;
          });
          if (newArr.length > 0) {
            // 有新加的模块，需要初始化
            _this2.inItBanner(newArr.map(function (m) {
              return {
                modelName: m.name,
                locations: [],
                category: m.category,
                backgroundMode: '',
                backgroundContent: '',
                enable: m.enable
              };
            }));
          }
          console.log(_this2.tableData, '0000000000');
          _this2.tableData.splice(0, 0);
        } else {
          // 需要初始化
          _this2.inItBanner(_this2.tableData.filter(function (i) {
            return i.category;
          }).map(function (m) {
            return {
              modelName: m.name,
              locations: [],
              category: m.category,
              backgroundMode: '',
              backgroundContent: '',
              enable: m.enable
            };
          }));
        }
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    inItBanner: function inItBanner(arr) {
      var _this3 = this;
      (0, _creatApp.initBannerModel)({
        region: 2,
        items: arr
      }).then(function () {
        _this3.findAll();
      });
    },
    delPic: function delPic() {
      var _this4 = this;
      this.$confirm('确定删除此图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.tableData[_this4.activeNum - 1].pic = '';
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              file = _ref.file;
              pictureUrl = '';
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file);
            case 1:
              pictureUrl = _context.v;
              this.tableData[this.activeNum - 1].pic = pictureUrl;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    setting: function setting(val) {
      console.log(val);
      if (val.category) {
        this.$refs.ModulePopup.open({
          name: val.name,
          id: val.id,
          region: val.region,
          category: val.category
        });
      }
      this.activeNum = val.actNum;
    },
    save: function save() {
      var _this5 = this;
      this.$confirm('确认是否保存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _creatApp.saveSetting)({
          itemKey: "localLife_".concat(_this5.activeNum),
          itemValue: JSON.stringify(_this5.tableData[_this5.activeNum - 1])
        }).then(function (res) {
          _this5.$notify.success({
            title: '温馨提示',
            message: '操作成功'
          });
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    goBack: function goBack() {
      this.activeNum = '';
    },
    changeStatus: function changeStatus(val) {
      var _this6 = this;
      this.$confirm(val.enable === 0 ? '确定关闭此模块?' : '确定开启此模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (val.actNum) {
          // 装修保存
          (0, _creatApp.saveSetting)({
            itemKey: "localLife_".concat(val.actNum),
            itemValue: JSON.stringify(val)
          }).then(function (res) {
            _this6.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        } else {
          // 模块保存
          if (val.category) {
            (0, _creatApp.updateBannerModelStatus)({
              id: val.id,
              enable: val.enable
            }).then(function () {
              _this6.findAll();
              _this6.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
            });
          }
        }
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消'
        });
        if (val.enable === 1) {
          val.enable = 0;
        } else {
          val.enable = 1;
        }
      });
    }
  }
};